import { getPercentage } from '@uw/utils';
import { IssueType, Violations } from 'constants/violations';

export function getChartData(
  violations: Violations,
  colors: Record<string, string>,
): { label: string; background: string; rotates: string[] } {
  if (!violations.totalCount) {
    return {
      label: '',
      background: '',
      rotates: [],
    };
  }

  let label = `${violations.totalCount} violations in total: `;
  let percentageSum = 0;
  const conicGradientValues: string[] = [];
  const rotates: string[] = [];

  const issueTypeCount = Object.values(IssueType).length;
  const lastIssueTypeIndex = issueTypeCount - 1;
  const secondLastIssueTypeIndex = issueTypeCount - 2;

  const getLabelSegment = (
    issueType: IssueType,
    percentage: number,
    segmentIndex: number,
  ): string => {
    let segment = `${issueType} issues ${percentage}%`;

    // segments are separated with comma, except the last segment that is separated by "and" word
    if (segmentIndex < secondLastIssueTypeIndex) {
      segment += ', ';
    } else if (segmentIndex < lastIssueTypeIndex) {
      segment += ' and ';
    }

    return segment;
  };

  const getConicGradientValue = (prevPercentageSum: number, colorIndex: string): string =>
    `${colors[colorIndex]} ${prevPercentageSum}% ${percentageSum}%`;

  const getRotateDegValue = (): string => {
    const DEGREES_IN_CIRCLE = 360;

    return `${Math.round(DEGREES_IN_CIRCLE * (percentageSum / 100))}deg`;
  };

  Object.values(IssueType)
    // Note: we are showing issue types in reverse order in the pie chart
    .reverse()
    .forEach((issueType, i) => {
      const percentage = getPercentage(violations[issueType].count, violations.totalCount, 2);

      // creates chart's label
      label += getLabelSegment(issueType, percentage, i);

      // generates background and rotate CSS values of pie chart
      if (percentage) {
        const prevPercentageSum = percentageSum;

        if (i < lastIssueTypeIndex) {
          percentageSum += percentage;
        } else {
          // note: at last issue, percentage sum is always 100%
          percentageSum = 100;
        }

        conicGradientValues.push(getConicGradientValue(prevPercentageSum, issueType));
        rotates.push(getRotateDegValue());
      }
    });

  return {
    label,
    background: `conic-gradient(${conicGradientValues.join(', ')})`,
    rotates,
  };
}
